export enum Logos {
    // mainLogo = "assets/img/logo-icon.png"
    mainLogo = "assets/img/logo 2.png"
}
